import type {
  FOOBetDetails,
  KambiSportBetDetails,
  LoadBetDetails,
} from '@core/Areas/ShareBet/LoadBet/types'

export const isKambiSportBetDetails = (bet: LoadBetDetails): bet is KambiSportBetDetails =>
  'betOfferIds' in bet

export const isFOOBetDetails = (bet: LoadBetDetails): bet is FOOBetDetails =>
  'propositionSeq' in bet
